const Result=require('./result');

function Error(error){
  Result.call(this,undefined,error);
}
Error.prototype = Object.create(Result.prototype);
module.exports=Error;